/* Cozify Bundle Builder — added 2026-09-07. Runs only when #bb-config exists (bundle products). */
(function () {
  function init() {
    var cfgEl = document.getElementById('bb-config');
    var dataEl = document.getElementById('bb-products');
    if (!cfgEl || !dataEl || window.__cozifyBB) return;
    var cfg, products;
    try { cfg = JSON.parse(cfgEl.textContent); products = JSON.parse(dataEl.textContent); } catch (e) { return; }
    window.__cozifyBB = true;
    // In-stock items first, sold-out last (keeps the collection order inside each group) — 2026-09-19.
    products = products.filter(function (p) { return p.available; }).concat(products.filter(function (p) { return !p.available; }));

    var slotsWrap = document.querySelector('[data-bb-slots]');
    var sheet = document.querySelector('[data-bb-sheet]');
    var overlay = document.querySelector('[data-bb-overlay]');
    if (!slotsWrap || !sheet || !overlay) return;
    document.body.appendChild(overlay); document.body.appendChild(sheet);
    var grid = sheet.querySelector('[data-bb-grid]');
    var titleEl = sheet.querySelector('[data-bb-title]');
    var motiveEl = sheet.querySelector('[data-bb-motive]');
    var pillEl = sheet.querySelector('[data-bb-pill]');
    var chips = sheet.querySelector('[data-bb-chips]');
    var mixed = cfg.hoodies > 0 && cfg.slippers > 0;
    if (mixed) chips.hidden = false;

    var slots = [];
    for (var i = 0; i < cfg.hoodies; i++) slots.push({ type: 'hoodie', item: null });
    for (var j = 0; j < cfg.slippers; j++) slots.push({ type: 'slippers', item: null });
    var st = { active: -1, filter: 'hoodie', revealed: false, busy: false };
    var TYPE = { hoodie: 'hoodie', slippers: 'slipper' };
    var ORD = ['1st', '2nd', '3rd', '4th', '5th', '6th'];

    function fmt(c) {
      try { if (typeof window.formatMoney === 'function') return window.formatMoney(c, cfg.moneyFormat); } catch (e) {}
      return '$' + (c / 100).toFixed(2);
    }
    function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function filled() { return slots.filter(function (s) { return s.item; }).length; }
    // Savings (2026-09-19): bundle saving = compare-at − bundle price; 'saved so far' grows with each pick.
    var saveTotal = Math.max(0, (cfg.bundleCompare || 0) - cfg.bundlePrice);
    var freeShip = cfg.bundlePrice >= (cfg.freeShipMin || 7000);
    function savedSoFar() { return Math.round(saveTotal * filled() / slots.length); }
    function perks() { return (saveTotal > 0 ? ' · You save ' + fmt(saveTotal) : '') + (freeShip ? ' + 🚚 Free Delivery' : ''); }
    function total() { return slots.length; }
    // Stock guard (2026-09-19): an item cannot be picked more times than it has pieces left.
    function pickedCount(id, exceptSlot) { return slots.filter(function (x, k) { return k !== exceptSlot && x.item && x.item.id === id; }).length; }
    function stockLeft(p, exceptSlot) { return (p.stock == null ? 9999 : p.stock) - pickedCount(p.id, exceptSlot); }
    function ordinalLabel(i) {
      var t = slots[i].type, n = 0;
      for (var k = 0; k <= i; k++) if (slots[k].type === t) n++;
      return 'Pick your ' + (ORD[n - 1] || (n + 'th')) + ' ' + TYPE[t];
    }
    function typeFull(t) { return !slots.some(function (s) { return s.type === t && !s.item; }); }
    function firstEmptyOfType(t) { for (var k = 0; k < slots.length; k++) if (slots[k].type === t && !slots[k].item) return k; return -1; }
    function firstEmpty() { for (var k = 0; k < slots.length; k++) if (!slots[k].item) return k; return -1; }

    function renderSlots() {
      var html = slots.map(function (s, i) {
        if (s.item) {
          return '<button type="button" class="bb-slot is-filled" data-bb-slot="' + i + '" aria-label="Change ' + esc(s.item.name) + '">' +
            '<span class="bb-slot__x" data-bb-clear="' + i + '" role="button" aria-label="Remove">✕</span>' +
            (s.item.img ? '<img src="' + esc(s.item.img) + '" alt="" loading="lazy">' : '') +
            '<span class="bb-slot__name">' + esc(s.item.name) + '</span>' +
            (mixed ? '<span class="bb-slot__type">' + esc(TYPE[s.type]) + '</span>' : '') +
            '</button>';
        }
        return '<button type="button" class="bb-slot is-empty" data-bb-slot="' + i + '">' +
          '<span class="bb-slot__plus">+</span><span class="bb-slot__label">' + esc(ordinalLabel(i)) + '</span></button>';
      }).join('');
      var n = filled(), t = total();
      if (n === t) html += '<div class="bb-summary is-ready">✓ ' + n + '/' + t + ' chosen · Adding your bundle · ' + esc(fmt(cfg.bundlePrice)) + esc(perks()) + '</div>';
      else html += '<div class="bb-summary">' + n + '/' + t + ' chosen · Choose ' + (t - n) + ' more' + (saveTotal > 0 && n > 0 ? ' · 💰 ' + esc(fmt(savedSoFar())) + ' saved so far' : '') + '</div>';
      html += '<div class="bb-error" data-bb-error hidden></div>';
      slotsWrap.setAttribute('data-count', String(total()));
      slotsWrap.innerHTML = html;
    }
    function showError(msg) { var e = slotsWrap.querySelector('[data-bb-error]'); if (e) { e.textContent = msg; e.hidden = false; } }

    function openSheet(i) {
      st.active = i;
      st.filter = slots[i] ? slots[i].type : 'hoodie'; // owner 2026-10-23: tab follows the slot being filled (no 'All')
      renderSheet();
      sheet.classList.add('is-open'); overlay.classList.add('is-open');
      document.body.classList.add('bb-lock'); sheet.setAttribute('aria-hidden', 'false');
    }
    function closeSheet() {
      sheet.classList.remove('is-open'); overlay.classList.remove('is-open');
      document.body.classList.remove('bb-lock'); sheet.setAttribute('aria-hidden', 'true');
    }
    function renderSheet() {
      var s = slots[st.active]; if (!s) return;
      var remaining = total() - filled();
      titleEl.textContent = ordinalLabel(st.active);
      var soFar = (saveTotal > 0 && filled() > 0) ? ('💰 ' + fmt(savedSoFar()) + ' saved so far · ') : '';
      motiveEl.textContent = remaining > 0 ? (soFar + 'Choose ' + remaining + ' more to unlock ' + fmt(cfg.bundlePrice) + perks()) : ('All set · ' + fmt(cfg.bundlePrice) + perks());
      pillEl.innerHTML = esc(fmt(cfg.bundlePrice)) + (saveTotal > 0 ? ' <s style="opacity:.6;font-weight:500">' + esc(fmt(cfg.bundleCompare)) + '</s>' : '') + ' · ' + filled() + '/' + total();
      if (mixed) {
        Array.prototype.forEach.call(chips.querySelectorAll('[data-bb-filter]'), function (c) { c.classList.toggle('is-active', c.getAttribute('data-bb-filter') === st.filter); });
      }
      var list = products.filter(function (p) {
        if (!mixed) return p.type === s.type;
        return p.type === st.filter;
      });
      grid.innerHTML = list.map(function (p, idx) {
        var out = !p.available;
        var full = !out && p.type !== s.type && typeFull(p.type);
        var taken = !out && !full && stockLeft(p, p.type === s.type ? st.active : -1) <= 0;
        var cls = 'bb-card' + (out ? ' is-out' : '') + ((full || taken) ? ' is-full' : '') + (s.item && s.item.id === p.id ? ' is-selected' : '');
        var priceTxt = out ? 'Sold out' : (full ? (TYPE[p.type] + ' slots full') : (taken ? ('Only ' + p.stock + ' left · picked') : fmt(p.price)));
        return '<button type="button" class="' + cls + '" data-bb-pick="' + p.id + '"' + ((out || full || taken) ? ' disabled' : '') + '>' +
          (mixed ? '<span class="bb-card__type">' + esc(TYPE[p.type]) + '</span>' : '') +
          (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') +
          '<span class="bb-card__name">' + esc(p.name) + '</span>' +
          '<span class="bb-card__price">' + esc(priceTxt) + '</span></button>';
      }).join('');
      var body = sheet.querySelector('.bb-sheet__body'); if (body) body.scrollTop = 0;
    }
    function pick(p) {
      var target = st.active;
      if (slots[target].type !== p.type) { target = firstEmptyOfType(p.type); if (target === -1) return; }
      if (stockLeft(p, target) <= 0) return;
      slots[target].item = p;
      renderSlots();
      var next = firstEmpty();
      if (next === -1) { closeSheet(); addBundle(); }
      else { st.active = next; st.filter = slots[next].type; renderSheet(); } // hoodies done → jumps to Slippers tab
    }

    // Fallback when /cart/add.js does not answer JSON (bot challenge, network proxy): classic form POST to /cart/add.
    function classicAdd(items) {
      var form = document.createElement('form'); form.method = 'POST'; form.action = '/cart/add'; form.style.display = 'none';
      items.forEach(function (it, i) {
        var add = function (n, v) { var inp = document.createElement('input'); inp.type = 'hidden'; inp.name = n; inp.value = v; form.appendChild(inp); };
        add('items[' + i + '][id]', it.id); add('items[' + i + '][quantity]', it.quantity);
        Object.keys(it.properties || {}).forEach(function (k) { add('items[' + i + '][properties][' + k + ']', it.properties[k]); });
      });
      var ret = document.createElement('input'); ret.type = 'hidden'; ret.name = 'return_to'; ret.value = '/cart'; form.appendChild(ret);
      document.body.appendChild(form); form.submit();
    }
    function addBundle() {
      if (st.busy || filled() < total()) return;
      var f = document.querySelector('[data-product-form][data-product-handle="' + cfg.bundleHandle + '"]');
      st.busy = true;
      var btn = f ? f.querySelector('.add-to-cart-btn') : null; if (btn) btn.setAttribute('aria-busy', 'true');
      var counts = {};
      slots.forEach(function (s) { counts[s.item.vid] = (counts[s.item.vid] || 0) + 1; });
      var props = { '_bundle': cfg.bundleHandle };
      var items = Object.keys(counts).map(function (vid) { return { id: parseInt(vid, 10), quantity: counts[vid], properties: props }; });
      var payload = { items: items, sections: 'cart-items,cart-footer,cart-item-count', sections_url: window.location.pathname };
      fetch(cfg.cartAddUrl || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) })
        .then(function (r) {
          return r.text().then(function (t) {
            var d = null; try { d = JSON.parse(t); } catch (e) {}
            if (!d) { throw { fallback: true }; }
            if (!r.ok) throw d;
            return d;
          });
        })
        .then(function (data) {
          document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', { bubbles: true, detail: { response: data, sourceId: f ? f.id : '' } }));
          slots.forEach(function (s) { s.item = null; });
          st.revealed = false; slotsWrap.hidden = true; slotsWrap.innerHTML = '';
        })
        .catch(function (err) {
          if (err && err.fallback) { classicAdd(items); return; }
          // Shopify answers {errors: "..."} when only part of the items fit the stock (some may already be in the cart).
          var partial = err && typeof err.errors === 'string' ? err.errors : '';
          showError(partial ? (partial + ' Please check your cart.') : ((err && (err.description || err.message)) || 'Could not add the bundle. Please try again.'));
        })
        .finally(function () { st.busy = false; if (btn) btn.removeAttribute('aria-busy'); });
    }

    document.addEventListener('click', function (e) {
      var clr = e.target.closest('[data-bb-clear]');
      if (clr) { e.preventDefault(); e.stopPropagation(); slots[parseInt(clr.getAttribute('data-bb-clear'), 10)].item = null; renderSlots(); return; }
      var slotBtn = e.target.closest('[data-bb-slot]');
      if (slotBtn) { e.preventDefault(); openSheet(parseInt(slotBtn.getAttribute('data-bb-slot'), 10)); return; }
      var pk = e.target.closest('[data-bb-pick]');
      if (pk && !pk.disabled) {
        var id = parseInt(pk.getAttribute('data-bb-pick'), 10);
        var p = products.filter(function (x) { return x.id === id; })[0];
        if (p) pick(p);
        return;
      }
      var chip = e.target.closest('[data-bb-filter]');
      if (chip) { st.filter = chip.getAttribute('data-bb-filter'); renderSheet(); return; }
      if (e.target.closest('[data-bb-close]') || e.target.closest('[data-bb-overlay]') || e.target.closest('[data-bb-done]')) { closeSheet(); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });

    // Capture-phase submit: wins over the theme's form-level listener on bundle products only.
    document.addEventListener('submit', function (e) {
      var f = e.target.closest ? e.target.closest('[data-product-form]') : null;
      if (!f || f.getAttribute('data-product-handle') !== cfg.bundleHandle) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!st.revealed) { st.revealed = true; slotsWrap.hidden = false; renderSlots(); }
      if (filled() < total()) {
        slotsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        openSheet(firstEmpty());
        return;
      }
      addBundle();
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
